import {ref} from 'vue';

export default function(loadingStatus){
	// loadingStatus should be a reactive object, not its value
	const loading = ref(loadingStatus || false);
	function loadingShow(){
		loading.value = true;
	}
	function loadingHide(){
		loading.value = false
	}
	
	return { loading, loadingShow, loadingHide}
}
